import {ToggleButton, ToggleButtonGroup} from '@mui/material';

export type StatusFilterValue = 'active' | 'inactive' | 'all';

export const DEFAULT_STATUS_FILTER: StatusFilterValue = 'active';

interface StatusFilterToggleProps {
   value: StatusFilterValue;
   onChange: (value: StatusFilterValue) => void;
}

/**
 * Three-state Active / Inactive / All toggle for the "Status" column,
 * meant to sit in a table's top toolbar just to the left of the search box.
 */
export function StatusFilterToggle({value, onChange}: StatusFilterToggleProps) {
   return (
      <ToggleButtonGroup
         value={value}
         exclusive
         size='small'
         onChange={(_e, next: StatusFilterValue | null) => {
            if (next !== null) onChange(next);
         }}
         aria-label='Status filter'
         sx={{mr: 1}}
      >
         <ToggleButton value='active' aria-label='Active'>
            Active
         </ToggleButton>
         <ToggleButton value='inactive' aria-label='Inactive'>
            Inactive
         </ToggleButton>
         <ToggleButton value='all' aria-label='All'>
            All
         </ToggleButton>
      </ToggleButtonGroup>
   );
}
